import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    createTextVNode as _$ct,
} from 'intact';
import {Tour, TourStep, Button, Icon} from 'kpc';

var _$tmp0 = {
    'href': 'javascript:;',
    'style': 'color: #2d8cf0'
};
var _$tmp1 = {
    'className': 'ion-android-star',
    'style': 'margin-right: 5px; color: #f0ad4e'
};
var _$tmp2 = {
    'style': 'margin-left: 8px; color: #999; font-size: 12px'
};
var _$tmp3 = {
    'style': 'display: flex; align-items: center'
};
var _$tmp4 = {
    'style': 'margin-top: 20px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ce(2, 'div', (
            _$cc(Button, {
                'id': 'btn5',
                'children': '示例元素'
            })
        ), 2, 'example-container'),
        _$cc(Tour, {
            'visible': this.get('showTour'),
            'ev-finish': this.close,
            'children': (
                _$cc(TourStep, {
                    'target': '#btn5',
                    'position': 'bottom',
                    'children': (
                        _$ce(2, 'div', [
                            _$ce(2, 'p', '这是一个自定义的复杂内容，可以包含图片、链接等任何元素。', 16),
                            _$ce(2, 'a', '了解更多', 16, null, _$tmp0)
                        ], 4, 'custom-content')
                    ),
                    '$blocks': function($blocks) {
                        var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                        return (
                            (
                                (_$blocks['header'] = function($super) {
                                    return (
                                        _$ce(2, 'div', [
                                            _$cc(Icon, _$tmp1),
                                            _$ce(2, 'span', '自定义标题', 16, 'custom-title'),
                                            _$ce(2, 'span', '带图标和样式', 16, null, _$tmp2)
                                        ], 4, null, _$tmp3)
                                    );
                                }),
                                (__$blocks['header'] = function($super, data) {
                                    var block = $blocks['header'];
                                    var callBlock = function() {
                                        return _$blocks['header'].call($this, $super, data);
                                    };
                                    return block ?
                                        block.call($this, callBlock, data) :
                                        callBlock();
                                })
                            ),
                            (
                                (_$blocks['footer'] = function($super) {
                                    return [
                                        _$ce(2, 'div', [
                                            this.get('currentStep') + 1,
                                            _$ct(' / 1')
                                        ], 0, 'step-indicator'),
                                        _$ce(2, 'div', [
                                            _$cc(Button, {
                                                'size': 'small',
                                                'type': 'danger',
                                                'style': 'margin-right: 8px;',
                                                'ev-click': this.close,
                                                'children': '跳过'
                                            }),
                                            _$cc(Button, {
                                                'size': 'small',
                                                'type': 'primary',
                                                'ev-click': this.close,
                                                'children': '我知道了'
                                            })
                                        ], 4, 'custom-footer')
                                    ];
                                }),
                                (__$blocks['footer'] = function($super, data) {
                                    var block = $blocks['footer'];
                                    var callBlock = function() {
                                        return _$blocks['footer'].call($this, $super, data);
                                    };
                                    return block ?
                                        block.call($this, callBlock, data) :
                                        callBlock();
                                })
                            ),
                            __$blocks
                        );
                    }.call($this, _$em)
                })
            ),
            'ev-$model:value': function($v) {
                $this.set('currentStep', $v);
            },
            'value': $this.get('currentStep')
        }),
        _$ce(2, 'div', (
            _$cc(Button, {
                'ev-click': this.settour,
                'children': '\n            启动自定义引导\n        '
            })
        ), 2, null, _$tmp4)
    ], 4);
};